import { IdentityProviderSettingsListItem } from '../../../integrated-client/models/';

export class ResultsData {
  items: Array<IdentityProviderSettingsListItem>;
  totalItems?: number;
  showMore: boolean;

  constructor() {
    this.items = [];
    this.showMore = false;
  }

}
